module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal-belly.4f50c8b7.png";